<template>
  <!-- 点検結果調査検索 -->
  <div id="AppFraudPreventionMeasures">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">点検結果調査検索</label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalCode"
                name="hospitalCode"
                data-vv-as="医療機関コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalName"
                name="hospitalName"
                data-vv-as="医療機関名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div horizontal class="column is-one-third">
            <b-field label="点検期間" labelPosition="on-border">
              <b-datepicker
                v-model="startDate"
                name="startDate"
                placeholder="検索開始年月日"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              >
                <button
                  class="button is-danger"
                  @click="startDate = null,searchConditions.startDate= ''"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
              <b-datepicker
                v-model="endDate"
                name="endDate"
                placeholder="検索終了年月日"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              >
                <button
                  class="button is-danger"
                  @click="endDate = null,searchConditions.endDate= ''"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffCode"
                name="staffCode"
                data-vv-as="点検担当者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffName"
                name="staffName"
                data-vv-as="点検担当者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.recipientCode"
                name="recipientCode"
                data-vv-as="患者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.recipientName"
                name="recipientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="住所" labelPosition="on-border">
              <b-input
                v-model="searchConditions.address"
                name="address"
                data-vv-as="住所"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--4行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="点検種別" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="0"
              >院内/当社点検有</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="1"
              >院内/当社点検無し</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="2"
              >在宅/当社点検</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="3"
              >在宅/ディーラー点検</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="4"
              >院内・在宅/RR点検不要</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.inspectionKindGroup" native-value="5">社内器</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="6"
              >
                フリーメンテ
              </b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="99"
              >未設定</b-checkbox-button>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="判定" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.reasonGroup"
                id="check0"
                native-value="0"
              >未判定</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.reasonGroup"
                id="check1"
                native-value="1"
              >問題有り</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.reasonGroup"
                id="check2"
                native-value="2"
              >問題無し</b-checkbox-button>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検実施状況" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.statusGroup"
                id="check0"
                native-value="0"
              >点検未実施</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.statusGroup"
                id="check1"
                native-value="1"
              >点検実施済み</b-checkbox-button>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン -->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span style="color: red" v-if="isSearchConditionNull">検索条件を指定してください。</span>
            <span style="color: red" v-if="isSearchConditionAll">全件検索となる為、検索条件を絞り込んでください。</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <section>
      <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
        <div class="columns">
          <div class="column is-one-half" style="text-align:left;">
            <b-button
              class="button is-primary has-text-centered"
              icon-left="download"
              native-type="button"
              v-on:click="downloadCSV"
            >CSVファイルダウンロード</b-button>
          </div>

          <div class="column">
            <b-field horizontal label="検索結果" style="float:right; white-space:nowrap;">
              <b-select position="is-right" v-model="perPage">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div>
          <b-table
            :data="data"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="scheduledMonth"
            detailed
            @details-open="(row, index)"
            checkable
            :checked-rows.sync="checkedRows"
            checkbox-position="left"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="id" label="予約番号" sortable centered>{{ props.row.id }}</b-table-column>
              <b-table-column
                field="reserveDate"
                label="点検予定日"
                sortable
                centered
              >{{ props.row.reserveDate}}</b-table-column>
              <b-table-column
                field="reserveTime"
                label="点検予定時刻"
                sortable
                centered
              >{{ props.row.reserveTime}}</b-table-column>
              <b-table-column
                field="inspectionDate"
                label="完了日付"
                sortable
                centered
              >{{ props.row.inspectionDate }}</b-table-column>
              <b-table-column
                field="inspectionTime"
                label="完了時刻"
                sortable
                centered
              >{{ props.row.inspectionTime}}</b-table-column>
              <b-table-column
                field="checkResult"
                label="判定"
                sortable
                centered
              >{{ props.row.checkResult | checkResultFilter() }}</b-table-column>
              <b-table-column field="concerns" label="確認事項" sortable centered style="align: left">
                <span
                  style="display:block; text-align: left"
                  v-html="changeBreak(props.row.concerns)"
                />
              </b-table-column>
              <b-table-column
                field="alternativeWriting"
                label="代理サイン"
                sortable
                centered
              >{{ props.row.alternativeWriting }}</b-table-column>
              <b-table-column
                field="recipientCode"
                label="患者コード"
                sortable
                centered
              >{{ props.row.recipientCode }}</b-table-column>
              <b-table-column
                field="recipientName"
                label="患者名"
                sortable
                centered
              >{{ props.row.recipientName }}</b-table-column>
              <b-table-column
                field="staffName"
                label="点検担当者"
                sortable
                centered
              >{{ props.row.staffName }}</b-table-column>
              <b-table-column
                field="senderSalesOfficeName"
                label="営業所"
                sortable
                centered
              >{{ props.row.senderSalesOfficeName }}</b-table-column>
              <b-table-column
                field="reason"
                label="理由"
                sortable
                centered
              >{{ props.row.reason | reasonFilter() }}</b-table-column>
              <b-table-column field="configuration" label="理由入力">
                <b-button
                  :disabled="srcRoleId==6"
                  class="button is-primary has-text-centered"
                  icon-left="pencil"
                  native-type="button"
                  v-on:click="inputReason(props.row)"
                ></b-button>
              </b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <div class="content">
                <table style="table-layout: fixed;">
                  <tr>
                    <th style="width:20%;">点検種別：</th>
                    <td>{{ props.row.inspectionType | inspectionTypeFillter()}}</td>
                  </tr>
                  <tr>
                    <th style="width:200px;">病院：</th>
                    <td>
                      {{ props.row.hospitalName}} (〒{{props.row.hospitalPostCode}} {{props.row.hospitalAddress}})
                      <b-field
                        v-if="
                          props.row.inspectionType == inspection.INSPECTION_TYPE_MAP.hospitalMyCompany.code && 
                          locationRequiredDisplay(props.row.concerns)
                        "
                        class="file"
                        style="float:right"
                      >
                        <b-button
                          class="button is-primary has-text-centered"
                          native-type="button"
                          icon-left="map-marker-off"
                          v-on:click="setLocationRequired(props.row.hospitalCode)"
                        >位置情報取得失敗を許可する</b-button>
                      </b-field>
                    </td>
                  </tr>
                  <tr>
                    <th>郵便番号：</th>
                    <td>{{ props.row.postCode}}</td>
                  </tr>
                  <tr>
                    <th>理由(フリー入力)：</th>
                    <td
                      style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"
                    >{{ props.row.reasonFree }}</td>
                  </tr>
                  <tr>
                    <th>システム管理者追記内容：</th>
                    <td
                      style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"
                    >{{ props.row.adminConfirmation }}</td>
                  </tr>
                  <tr>
                    <th>患者営業所：</th>
                    <td
                      style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"
                    >{{ getOfficeName(props.row.recipientOffice) }}</td>
                  </tr>
                  <tr>
                    <th>患者住所：</th>
                    <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">
                      <span>〒{{props.row.recipientPostCode}} {{props.row.recipientAddress}}</span>
                      <b-field
                        v-if="
                          props.row.inspectionType == inspection.INSPECTION_TYPE_MAP.homeMyCompany.code && 
                          locationRequiredDisplay(props.row.concerns)
                        "
                        class="file"
                        style="float:right"
                      >
                        <b-button
                          class="button is-primary has-text-centered"
                          native-type="button"
                          icon-left="map-marker-off"
                          v-on:click="setLocationRequired(props.row.recipientCode)"
                        >位置情報取得失敗を許可する</b-button>
                      </b-field>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div>
        <b-button
          v-if="srcRoleId!=6"
          class="button is-primary has-text-centered"
          icon-left="pencil"
          native-type="button"
          :disabled="!(checkedRows.length > 0)"
          v-on:click="inputReason(checkedRows)"
        >理由入力</b-button>
        <b-button
          v-if="srcRoleId==1"
          class="button is-primary has-text-centered"
          icon-left="check"
          native-type="button"
          :disabled="!(checkedRows.length > 0)"
          v-on:click="isCheckModalActive=true"
        >問題無し確認</b-button>
      </div>
      <b-modal :active.sync="isComponentModalActive" has-modal-card full-screen>
        <input-reason-modal
          v-bind:items="inputReasonInfos"
          v-bind:inputAdminFlag="adminConfirmationFlag"
          v-on:set-reason="RegistrationReason"
        ></input-reason-modal>
      </b-modal>
      <b-modal :active.sync="isCheckModalActive" has-modal-card full-screen>
        <input-check-modal v-bind:items="checkedRows" v-on:set-check="inputCheck"></input-check-modal>
      </b-modal>
    </section>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import * as inspection from "../utils/inspection"

const InputReasonTemplate = {
  props: ["items", "inputAdminFlag"],
  data() {
    var reason = null;
    var reasonFree = "";
    var reasonSelectList = [
      { key: null, value: "" },
      { key: 1, value: "点検実施場所での電波状況が悪く、後から処理" },
      { key: 2, value: "電子機器の持ち込みが禁止の為、後から処理" },
      { key: 3, value: "アポイント日時変更の未処理" },
      { key: 4, value: "不正あり（理由入力）" },
      { key: 5, value: "その他（理由入力）" }
    ];
    var appointmentInfos = [];
    if (this.$props.items.length == undefined) {
      // Object
      var obj = JSON.parse(JSON.stringify(this.$props.items));
      appointmentInfos.push(obj);
      reason = obj.reason;
      reasonFree = obj.reasonFree;
    } else {
      // array
      appointmentInfos = JSON.parse(JSON.stringify(this.$props.items));
    }
    // 予約番号の重複削除
    appointmentInfos = appointmentInfos.filter(function(v1, i1, a1) {
      return (
        a1.findIndex(function(v2) {
          return v1.id === v2.id;
        }) === i1
      );
    });
    // 予約番号順でソート
    appointmentInfos = appointmentInfos.sort((a, b) => {
      return Number(a.id) < Number(b.id)
        ? -1
        : Number(a.id) > Number(b.id)
        ? 1
        : 0;
    });
    for (var i = 0; i < appointmentInfos.length; i++) {
      appointmentInfos[i].concerns = appointmentInfos[i].concerns
        .split("/")
        .join("<br>　　　　　");
    }

    return {
      reason,
      reasonFree,
      reasonSelectList,
      appointmentInfos,
      isRegistrationAdmin: this.$props.inputAdminFlag
    };
  },
  methods: {
    RegistrationReason: function(event) {
      const appointmentCodes = this.appointmentInfos.map(obj => obj.id);
      // 理由の登録処理呼び出し
      this.$emit("set-reason", appointmentCodes, this.reason, this.reasonFree);
      // モーダルを閉じる
      this.close();
    },
    clear: function(event) {
      this.reason = "";
      this.reasonFree = "";
    },
    close: function(event) {
      // モーダル閉じる
      this.$parent.close();
    },
    getReason: function(value) {
      switch (value) {
        case 1:
          return "点検実施場所での電波状況が悪く、後から処理";
          break;
        case 2:
          return "電子機器の持ち込みが禁止の為、後から処理";
          break;
        case 3:
          return "アポイント日時変更の未処理";
          break;
        case 4:
          return "不正あり（理由入力）";
          break;
        case 5:
          return "その他（理由入力）";
          break;
        default:
          return value;
          break;
      }
    }
  },
  filters: {
    checkResultFilter: function(value) {
      switch (value) {
        case 0:
          return "〇";
          break;
        case 1:
          return "×";
          break;
        default:
          return value;
          break;
      }
    }
  },
  mounted() {},
  template: `
        <form action="">
            <div class="modal-card" style="width: 100%;">
                <header class="modal-card-head">
                    <p class="modal-card-title" style="color: whitesmoke; text-align: left">理由入力</p>
                </header>
                <section class="modal-card-body" style="width: 100%;text-align: left">
                  <div v-for="(item, index) in appointmentInfos" v-bind:key="index">
                    <td style="padding-left: 5px; width: 4%; font-size:20px;">
                      予約番号：{{item.id}}
                    </td>
                    <td style="padding-left: 5px; width: 1%; font-size:20px;">
                      判定：{{ item.checkResult | checkResultFilter() }}
                    </td>
                    <td style="padding-left: 5px; width: 10%; font-size:20px;">
                      確認事項：<span v-html="item.concerns" />
                    </td>
                    <td style="padding-left: 5px; width: 10%; font-size:20px;">
                      理由：<span v-html="getReason(item.reason)" />
                    </td>
                  </div>
                  <div style="text-align: left;margin-top:20px;font-size:20px;">【理由選択】</div>
                  <div style="width: 98%;">
                    <b-field
                        :type="{'is-danger':errors.has('reason')}"
                        :message="errors.first('reason')"
                      >
                      <b-select expanded size="is-medium" v-model="reason">
                        <option
                         v-for="selectItem in reasonSelectList"
                         :value="selectItem.key"
                         :key="selectItem.key"
                         :disabled="isRegistrationAdmin"
                         >{{ selectItem.value }}</option>
                      </b-select>
                    </b-field>
                  </div>
                  <div style="text-align: left;margin-top:20px;font-size:20px;">【理由入力】</div>
                  <div align="center" style="width: 98%;margin-top:10px;">
                    <b-field
                        :type="{'is-danger':errors.has('reasonFree')}"
                        :message="errors.first('reasonFree')"
                      >
                        <b-input
                          v-model="reasonFree"
                          :readOnly="isRegistrationAdmin"
                          name="reasonFree"
                          data-vv-as="理由"
                          type="textarea"
                          size="is-large"
                          style="width: 100%; height:30%;"
                          v-validate="'max:512'"
                          maxlength="512"
                        />
                      </b-field>
                  </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button class="button" type="button" @click="RegistrationReason()" :disabled="isRegistrationAdmin">登録する</b-button>
                    <b-button class="button" type="button" @click="clear()" :disabled="isRegistrationAdmin">クリア</b-button>
                    <button class="button" type="button" @click="$parent.close()">戻る</button>
                    <span style="color: white" v-if="isRegistrationAdmin">※既にシステム管理者が確認済みの為、編集できません。</span>
                </footer>
            </div>
        </form>
      `
};

const InputCheckTemplate = {
  props: ["items"],
  data() {
    var reasonSelectList = [
      { key: 1, value: "点検実施場所での電波状況が悪く、後から処理" },
      { key: 2, value: "電子機器の持ち込みが禁止の為、後から処理" },
      { key: 3, value: "アポイント日時変更の未処理" },
      { key: 4, value: "不正あり（理由入力）" },
      { key: 5, value: "その他（理由入力）" }
    ];
    var appointmentInfos = JSON.parse(JSON.stringify(this.$props.items));

    // 予約番号の重複削除
    appointmentInfos = appointmentInfos.filter(function(v1, i1, a1) {
      return (
        a1.findIndex(function(v2) {
          return v1.id === v2.id;
        }) === i1
      );
    });
    // 予約番号順でソート
    appointmentInfos = appointmentInfos.sort((a, b) => {
      return Number(a.id) < Number(b.id)
        ? -1
        : Number(a.id) > Number(b.id)
        ? 1
        : 0;
    });
    for (var i = 0; i < appointmentInfos.length; i++) {
      appointmentInfos[i].concerns = appointmentInfos[i].concerns
        .split("/")
        .join("<br>　　　　　");
    }

    return {
      addReason: "",
      reasonSelectList,
      appointmentInfos
    };
  },
  methods: {
    RegistrationCheck: function(event) {
      const appointmentCodes = this.appointmentInfos.map(obj => obj.id);
      // 理由の登録処理呼び出し
      this.$emit("set-check", this.addReason);
      // モーダルを閉じる
      this.close();
    },
    clear: function(event) {
      this.addReason = "";
    },
    close: function(event) {
      // モーダル閉じる
      this.$parent.close();
    },
    getReason: function(value) {
      switch (value) {
        case 1:
          return "点検実施場所での電波状況が悪く、後から処理";
          break;
        case 2:
          return "電子機器の持ち込みが禁止の為、後から処理";
          break;
        case 3:
          return "アポイント日時変更の未処理";
          break;
        case 4:
          return "不正あり（理由入力）";
          break;
        case 5:
          return "その他（理由入力）";
          break;
        default:
          return value;
          break;
      }
    }
  },
  filters: {
    checkResultFilter: function(value) {
      switch (value) {
        case 0:
          return "〇";
          break;
        case 1:
          return "×";
          break;
        default:
          return value;
          break;
      }
    }
  },
  mounted() {},
  template: `
        <form action="">
            <div class="modal-card" style="width: 100%;">
                <header class="modal-card-head">
                    <p class="modal-card-title" style="color: whitesmoke; text-align: left">問題無し確認</p>
                </header>
                <section class="modal-card-body" style="width: 100%;text-align: left">
                  <div v-for="(item, index) in appointmentInfos" v-bind:key="index">
                    <td style="padding-left: 5px; width: 4%; font-size:20px;">
                      予約番号：{{item.id}}
                    </td>
                    <td style="padding-left: 5px; width: 1%; font-size:20px;">
                      判定：{{ item.checkResult | checkResultFilter() }}
                    </td>
                    <td style="padding-left: 5px; width: 10%; font-size:20px;">
                      確認事項：<span v-html="item.concerns" />
                    </td>
                    <td style="padding-left: 5px; width: 10%; font-size:20px;">
                      理由：<span v-html="getReason(item.reason)" />
                    </td>
                  </div>
                  <div style="text-align: left;margin-top:20px;font-size:20px;">【システム管理者理由入力】</div>
                  <div align="center" style="width: 98%;margin-top:10px;">
                    <b-field
                        :type="{'is-danger':errors.has('addReason')}"
                        :message="errors.first('addReason')"
                      >
                        <b-input
                          v-model="addReason"
                          name="addReason"
                          data-vv-as="理由"
                          type="textarea"
                          size="is-large"
                          style="width: 100%; height:30%;"
                          v-validate="'max:512'"
                          maxlength="512"
                        />
                      </b-field>
                  </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button class="button" type="button" @click="RegistrationCheck()">登録する</b-button>
                    <b-button class="button" type="button" @click="clear()">クリア</b-button>
                    <button class="button" type="button" @click="$parent.close()">戻る</button>
                </footer>
            </div>
        </form>
      `
};

export default {
  name: "AppFraudPreventionMeasures",
  methods: {
    getOfficeName: function(value) {
      return value.split(",").join("\n");
    },
    changeBreak: function(val) {
      return val.split("/").join("<br>");
    },
    search: function(event) {
      this.checkedRows = [];
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.recipientCode) ||
        this.isLength(this.searchConditions.recipientName) ||
        this.isLength(this.searchConditions.address) ||
        this.searchConditions.reasonGroup.length > 0 ||
        this.searchConditions.inspectionKindGroup.length > 0 ||
        this.searchConditions.statusGroup.length > 0
      ) {
        console.log("検索条件あり");
        this.isSearchConditionNull = false;
        if (
          !this.startDate &&
          !this.endDate &&
          !this.isLength(this.searchConditions.officeCode) &&
          !this.isLength(this.searchConditions.hospitalCode) &&
          !this.isLength(this.searchConditions.hospitalName) &&
          !this.isLength(this.searchConditions.staffCode) &&
          !this.isLength(this.searchConditions.staffName) &&
          !this.isLength(this.searchConditions.recipientCode) &&
          !this.isLength(this.searchConditions.recipientName) &&
          !this.isLength(this.searchConditions.address)
        ) {
          if (
            this.isSearchAll(
              [this.searchConditions.reasonGroup.length, 3],
              [this.searchConditions.inspectionKindGroup.length, 7],
              [this.searchConditions.statusGroup.length, 2]
            )
          ) {
            this.isSearchConditionAll = true;
            return;
          }
        }
        this.isSearchConditionAll = false;
        // 検索条件の整形
        if (this.startDate && !(typeof this.startDate == "string")) {
          this.searchConditions.startDate = this.formatDate(this.startDate);
        }
        if (this.endDate && !(typeof this.endDate == "string")) {
          this.searchConditions.endDate = this.formatDate(this.endDate);
        }
        for (var a in this.searchConditions.inspectionKindGroup) {
          this.searchConditions.inspectionKindGroup[a] = parseInt(
            this.searchConditions.inspectionKindGroup[a]
          );
        }
        var excuteApi = this.getInspectionCompletedListPOST;
        var successCallBack = this.getInspectionCompletedListPOSTSuccess;
        var errorCallBack = this.getInspectionCompletedListPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionAll = false;
        this.isSearchConditionNull = true;
      }
    },
    getInspectionCompletedListPOST: function(client) {
      var req = {
        officeCode: this.searchConditions.officeCode,
        hospitalCode: this.searchConditions.hospitalCode,
        hospitalName: this.searchConditions.hospitalName,
        startDate: this.searchConditions.startDate,
        endDate: this.searchConditions.endDate,
        staffCode: this.searchConditions.staffCode,
        staffName: this.searchConditions.staffName,
        recipientCode: this.searchConditions.recipientCode,
        recipientName: this.searchConditions.recipientName,
        address: this.searchConditions.address,
        inspectionType: this.searchConditions.inspectionKindGroup,
        reasonInputType: this.searchConditions.reasonGroup,
        statusGroup: this.searchConditions.statusGroup
      };
      return client.apis.apiInspection.getInspectionCompletedListPOST({
        body: req
      });
    },
    getInspectionCompletedListPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      for (var a in this.searchConditions.inspectionKindGroup) {
        this.searchConditions.inspectionKindGroup[a] =
          this.searchConditions.inspectionKindGroup[a] + "";
      }
    },
    getInspectionCompletedListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      for (var a in this.searchConditions.inspectionKindGroup) {
        this.searchConditions.inspectionKindGroup[a] =
          this.searchConditions.inspectionKindGroup[a] + "";
      }
    },
    downloadCSV: function(event) {
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.recipientCode) ||
        this.isLength(this.searchConditions.recipientName) ||
        this.isLength(this.searchConditions.address) ||
        this.searchConditions.reasonGroup.length > 0 ||
        this.searchConditions.inspectionKindGroup.length > 0 ||
        this.searchConditions.statusGroup.length > 0
      ) {
        console.log("CSVファイルダウンロード条件あり");
        this.isSearchConditionNull = false;
        if (
          !this.startDate &&
          !this.endDate &&
          !this.isLength(this.searchConditions.officeCode) &&
          !this.isLength(this.searchConditions.hospitalCode) &&
          !this.isLength(this.searchConditions.hospitalName) &&
          !this.isLength(this.searchConditions.staffCode) &&
          !this.isLength(this.searchConditions.staffName) &&
          !this.isLength(this.searchConditions.recipientCode) &&
          !this.isLength(this.searchConditions.recipientName) &&
          !this.isLength(this.searchConditions.address)
        ) {
          if (
            this.isSearchAll(
              [this.searchConditions.reasonGroup.length, 3],
              [this.searchConditions.inspectionKindGroup.length, 7],
              [this.searchConditions.statusGroup.length, 2]
            )
          ) {
            this.isSearchConditionAll = true;
            return;
          }
        }
        this.isSearchConditionAll = false;
        // 検索条件の整形
        if (this.startDate && !(typeof this.startDate == "string")) {
          this.searchConditions.startDate = this.formatDate(this.startDate);
        }
        if (this.endDate && !(typeof this.endDate == "string")) {
          this.searchConditions.endDate = this.formatDate(this.endDate);
        }
        for (var a in this.searchConditions.inspectionKindGroup) {
          this.searchConditions.inspectionKindGroup[a] = parseInt(
            this.searchConditions.inspectionKindGroup[a]
          );
        }
        // Web Api Call
        var excuteApi = this.downloadInspectionCompletedCSVFilePOST;
        var errorCallBack = this.downloadInspectionCompletedCSVFileError;
        this.downloadApiCall(excuteApi, errorCallBack);
      } else {
        console.log("CSVファイルダウンロード条件未入力");
        this.isSearchConditionAll = false;
        this.isSearchConditionNull = true;
        // this.showErrorMessage(
        //   "CSVファイルダウンロード条件を指定してください。<br>・営業所コード<br>・点検期間"
        // );
      }
    },
    downloadInspectionCompletedCSVFilePOST: function(client) {
      var req = {
        officeCode: this.searchConditions.officeCode,
        hospitalCode: this.searchConditions.hospitalCode,
        hospitalName: this.searchConditions.hospitalName,
        startDate: this.searchConditions.startDate,
        endDate: this.searchConditions.endDate,
        staffCode: this.searchConditions.staffCode,
        staffName: this.searchConditions.staffName,
        recipientCode: this.searchConditions.recipientCode,
        recipientName: this.searchConditions.recipientName,
        address: this.searchConditions.address,
        inspectionType: this.searchConditions.inspectionKindGroup,
        reasonInputType: this.searchConditions.reasonGroup,
        statusGroup: this.searchConditions.statusGroup
      };
      return client.apis.apiInspection.downloadInspectionCompletedCSVFilePOST({
        body: req
      });
    },
    downloadInspectionCompletedCSVFileError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    inputReason(items) {
      var isAdminConfirmation = false;
      var isRegisteredReason = false;

      if (items.length == undefined && items.adminConfirmation) {
        isAdminConfirmation = true;
      }

      for (var i = 0; i < items.length; i++) {
        if (items[i].adminConfirmation) {
          isAdminConfirmation = true;
        }
        if (items[i].reason) {
          isRegisteredReason = true;
          break;
        }
      }
      if (isRegisteredReason) {
        // 理由入力済みの場合
        this.$dialog.confirm({
          title: "　",
          message:
            "既に理由が登録されている点検情報が選択されています。<br>理由入力画面を開きますか？",
          cancelConfirm: () => {
            return;
          },
          onConfirm: () => {
            this.inputReasonInfos = items;
            this.isComponentModalActive = true;
            this.adminConfirmationFlag = isAdminConfirmation;
          }
        });
      } else {
        this.inputReasonInfos = items;
        this.isComponentModalActive = true;
        this.adminConfirmationFlag = isAdminConfirmation;
      }
    },
    RegistrationReason: function(reservationIds, reason, reasonFree) {
      this.reason = reason ? reason : null;
      this.reasonFree = reasonFree;
      this.reservationIds = reservationIds;
      if (reason) {
        this.checkResult = reason == 4 ? 1 : 0;
      }
      // Web Api Call
      var excuteApi = this.RegistrationReasonPOST;
      var successCallBack = this.RegistrationReasonPOSTSuccess;
      var errorCallBack = this.RegistrationReasonPOSTError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    RegistrationReasonPOST: function(client) {
      for (var item in this.reservationIds) {
        this.reservationIds[item] = Number(this.reservationIds[item]);
      }
      return client.apis.apiInspection.registrationReasonPOST({
        body: {
          reason: this.reason,
          reasonFree: this.reasonFree,
          reservationIds: this.reservationIds,
          checkResult: this.checkResult
        }
      });
    },
    RegistrationReasonPOSTSuccess: function(result) {
      this.reason = null;
      this.reasonFree = "";
      this.reservationIds = null;
      this.inputReasonInfos = "";
      this.adminConfirmationFlag = false;
      this.checkResult = null;
      // 成功メッセージ表示
      this.showSuccess(result);

      // 再検索
      this.search();
    },
    RegistrationReasonPOSTError: function(result) {
      this.reason = null;
      this.reasonFree = "";
      this.reservationIds = null;
      this.inputReasonInfos = "";
      this.adminConfirmationFlag = false;
      this.checkResult = null;
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    inputCheck: function(addReason) {
      var checkLows = this.checkedRows;
      // 予約番号順でソート
      checkLows = checkLows.sort((a, b) => {
        return Number(a.id) < Number(b.id)
          ? -1
          : Number(a.id) > Number(b.id)
          ? 1
          : 0;
      });
      var ids = [];
      for (var i = 0; i < checkLows.length; i++) {
        if (ids.indexOf(checkLows[i].id) == -1) {
          ids.push(checkLows[i].id);
        }
      }

      this.reasonFree = addReason;
      this.reservationIds = ids;
      this.checkResult = 99;
      // Web Api Call
      var excuteApi = this.RegistrationReasonPOST;
      var successCallBack = this.RegistrationReasonPOSTSuccess;
      var errorCallBack = this.RegistrationReasonPOSTError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    // this.back();
    // back: function(event) {
    //       // 遷移元画面への遷移処理
    //       this.$router.push({
    //         name: this.prevRoute,
    //         params: { searchConditions: this.searchConditions }
    //       });
    //     },

    locationRequiredDisplay: function(concerns){
      const GET_LOCATION_ERROR = "位置情報取得失敗";
      let res = false;
      if(concerns.includes(GET_LOCATION_ERROR)){
        res = true;
      }

      return res;
    },

    setLocationRequired: function(code) {
      this.code = code;
      let excuteApi = this.setLocationRequiredPOST;
      let successCallBack = this.setLocationRequiredPOSTSuccess;
      let errorCallBack = this.setLocationRequiredPOSTError;

      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setLocationRequiredPOST: function(client) {
      let req = {
        code: this.code,
        locationRequired: false,
      };
      return client.apis.apiMaster.setLocationRequiredPOST({
        body: req
      });
    },
    setLocationRequiredPOSTSuccess: function(result) {
      if (result.obj) {
        this.showSuccess(result);
      }
      this.code = null;
      // 再検索
      this.search();
      return;
    },
    setLocationRequiredPOSTError: function(result) {
      this.showErrorMessage(result);
      this.code = null;
    },
  },
  data() {
    var data = [];
    var setInfo = {};
    var setInspectionKindInfo = {};
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var srcRoleId = userInfo.srcRoleId;
    var officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    var searchConditions = {
      officeCode: "",
      hospitalCode: "",
      hospitalName: "",
      startDate: "",
      endDate: "",
      staffCode: "",
      staffName: "",
      recipientCode: "",
      recipientName: "",
      address: "",
      inspectionKindGroup: [],
      reasonGroup: [],
      statusGroup: []
    };
    var startDate = null;
    var endDate = null;
    // if (this.$route.params["searchConditions"]) {
    //   searchConditions = this.$route.params["searchConditions"];
    //   if (
    //     typeof searchConditions.startDate == "string" &&
    //     searchConditions.startDate != ""
    //   ) {
    //     startDate = this.parseDateMonth(searchConditions.startDate);
    //   }
    //   if (
    //     typeof searchConditions.endDate == "string" &&
    //     searchConditions.endDate != ""
    //   ) {
    //     endDate = this.parseDateMonth(searchConditions.endDate);
    //   }
    // } else {
    //   if (userInfo.roleId != 1) {
    //     searchConditions.officeCode = userInfo.officeCode;
    //     searchConditions.staffCode = userInfo.staffCode;
    //     searchConditions.staffName = userInfo.fullName;
    //   }
    // }
    return {
      data,
      setInfo,
      setInspectionKindInfo,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      defaultOpenedDetails: [1],
      currentPage: 1,
      perPage: 10,
      checkedRows: [],
      isStaffChangeModalActive: false,
      isKindChangeModalActive: false,
      staffChangedInspectionCode: "",
      staffChangedInspectionCodes: [],
      searchConditions,
      startDate,
      endDate,
      isSearchConditionNull: false,
      isSearchConditionAll: false,
      addressList: [],
      officeMaster,
      userInfo,
      roleId,
      srcRoleId,
      isComponentModalActive: false,
      isCheckModalActive: false,
      inputReasonInfos: {},
      adminConfirmationFlag: false,
      reason: null,
      reasonFree: "",
      reservationIds: null,
      checkResult: null,
      code: null,
      inspection,
    };
  },
  filters: {},
  components: {
    "input-reason-modal": InputReasonTemplate,
    "input-check-modal": InputCheckTemplate
  },
  created: function () {
    this.searchConditions.inspectionKindGroup = ["0", "2"];
  },

  mounted: function () {
    //サイドメニューから遷移時は初期検索をしない
    if (this.$route.params["searchConditions"]) {
      this.search();
    }
  },
  filters: {
    officeFilter: function(value, officeMaster) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    reasonFilter: function(value) {
      switch (value) {
        case 1:
          return "点検実施場所での電波状況が悪く、後から処理";
          break;
        case 2:
          return "電子機器の持ち込みが禁止の為、後から処理";
          break;
        case 3:
          return "アポイント日時変更の未処理";
          break;
        case 4:
          return "不正あり（理由入力）";
          break;
        case 5:
          return "その他（理由入力）";
          break;
        default:
          return value;
          break;
      }
    },
    checkResultFilter: function(value) {
      switch (value) {
        case 0:
          return "〇";
          break;
        case 1:
          return "×";
          break;
        default:
          return value;
          break;
      }
    }
  }
};
</script>
<style>
.dialog .modal-card .modal-card-foot .button {
  background-color: rgb(255, 255, 255);
  color: rgb(36, 36, 36);
}
</style>


// WEBPACK FOOTER //
// src/components/AppFraudPreventionMeasures.vue